<template>
  <div class="container form-bg bg-white">
    <div class="py-2 text-center">
      <h2>客戶基本資料</h2>
      <hr />
      <div class="col-md-12 order-md-1">
        <!-- function-button-group -->
        <div class="row">
          <div class="col-md-12 mb-1">
            <div class="function-button-group">
              <a class="btn gray-btn active" :href="urlBack">回上層選單</a>
              <a class="btn gray-btn active" id="query">查詢</a>
              <a class="btn gray-btn active" id="query_cancel">清除</a>
              <a v-if="isEdit" class="btn gray-btn active" id="reload">取消</a>
              <a v-if="isEdit" class="btn gray-btn active" id="edit">編輯</a>
              <a
                v-if="isEdit"
                class="btn gray-btn active"
                id="history"
                @click="getHistory()"
                >歷史案件</a
              >
              <a v-if="!isEdit" class="btn gray-btn active" id="submit">存檔</a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <form id="d_customer_freeform" class="form_format">
          <input type="hidden" name="_token" :value="csrfToken" />
          <customer-form-component
            :is-edit="isEdit"
            :page-search="pageSearch"
            :input-type-info="inputTypeInfo"
            :old-input="oldInput"
            :data-type-contentSearch="dataTypeContentSearch"
            :voyager-generic-none="voyagerGenericNone"
            :relation-url="relationUrl"
            :row="row"
            :options="options"
            :relationship-data="relationshipData"
          />
        </form>

        <div v-if="isServerSide" class="pull-left">
          <div role="status" class="show-res" aria-live="polite">
            {{ pageInfo }}
          </div>
        </div>
        <div class="pull-right mt-3">
          <pagination :pagination="pagination" />
        </div>
      </div>
    </div>

    <customer-history-modal-component
      v-model="historyModal"
      :case-url="caseUrl"
      :history-data="historyData"
    />
  </div>
</template>

<script>
import CustomerHistoryModalComponent from "./historyModal/CustomerHistoryModalComponent.vue";
export default {
  components: { CustomerHistoryModalComponent },
  data() {
    return { historyModal: null, historyData: [] };
  },
  props: {
    urlBack: {
      type: String,
      default: "",
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    csrfToken: {
      type: String,
      default: "",
    },
    isServerSide: {
      type: Boolean,
      default: false,
    },
    pageSearch: {
      type: Object,
      default: () => ({}),
    },
    inputTypeInfo: {
      type: Object,
      default: () => ({}),
    },
    oldInput: {
      type: Object,
      default: () => ({}),
    },
    dataTypeContentSearch: {
      type: Object,
      default: () => ({}),
    },
    voyagerGenericNone: {
      type: String,
      default: "",
    },
    relationUrl: {
      type: String,
      default: "",
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    relationshipData: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    pageInfo: {
      type: String,
      default: "",
    },
    historyUrl: {
      type: String,
      default: "",
    },
    caseUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    getHistory() {
      const vm = this;
      super_ajax({
        url: this.historyUrl.replace("__id", this.pageSearch.id),
        type: "GET",
        success: function (obj) {
          if (obj.success) {
            vm.historyData = [...obj.data];
            vm.historyModal.show();
          } else {
            alertModal("提示", "讀取發生錯誤");
          }
        },
        error: function (jqXHR, exception) {
          var msg = "";
          if (jqXHR.status === 0) {
            msg = "Not connect.\n Verify Network.";
          } else if (jqXHR.status == 404) {
            msg = "Requested page not found. [404]";
          } else if (jqXHR.status == 500) {
            msg = "Internal Server Error [500].";
          } else if (exception === "parsererror") {
            msg = "Requested JSON parse failed.";
          } else if (exception === "timeout") {
            msg = "Time out error.";
          } else if (exception === "abort") {
            msg = "Ajax request aborted.";
          } else {
            msg = "Uncaught Error.\n" + jqXHR.responseText;
          }
          alertModal("提示", msg);
        },
      });
    },
  },
};
</script>
